(function ($) {
  function bootReservationOverlay() {
    /* parseUri.options.strictMode = true;
        var url = parseUri(window.location.href);
        if(parseInt(url.queryKey.reserve) === 1){
            return openReserveOverlay();
        } */
  }

  if (document.readyState === 'complete') {
    bootReservationOverlay();
  } else {
    $(window).on('load', bootReservationOverlay);
  }

  $(document).ready(() => {
    const nav = $('.nav');
    const montageReserve = $('#reserve-montage');
    const pendryReserve = $('#reserve-pendry');

    const $overlay = $('.reservation-overlay');
    const $button = $('#open-reservation-overlay');
    const $cross = $('#close-reservation-overlay');

    /**
     * Close reserve overlay
     * @return void
     */
    function closeReseveOverlay() {
      $('body').removeClass('overflow-hidden');
      $button.removeClass('d-none');
      $cross.parent('.c-button--reservation-close').addClass('d-none');
      $overlay.slideUp();
      $button.focus();
    }

    nav.on('open', () => {
      closeReseveOverlay();
    });

    /**
     * Open reserve overlay
     * @return void
     */
    function openReserveOverlay() {
      $('body').addClass('overflow-hidden');
      $button.addClass('d-none');
      $cross.parent('.c-button--reservation-close').removeClass('d-none');
      $overlay.slideDown({
        start() {
          $(this).css({
            display: 'flex',
          });
        },
      });
      $cross.focus();
    }

    $button.on('click', () => {
      openReserveOverlay();

      if ($('.c-hamburger').hasClass('open')) {
        $('.c-hamburger').trigger('click');
      }
    });

    $cross.on('click', () => {
      closeReseveOverlay();
    });

    $cross.on('keydown', (event) => {
      if (event.keyCode === 9) {
        montageReserve.focus();
        event.preventDefault();
      }
    });

    pendryReserve.on('keydown', (event) => {
      if (event.keyCode === 9) {
        $cross.focus();
        event.preventDefault();
      }
    });

    $('#reserve-montage, #reserve-pendry').on('change', function (e) {
      const value = $(this).val();

      if (value) {
        $(this).addClass('reservation-overlay__select--selected');
        window.location.href = value;
      }

      e.preventDefault();
      return false;
    });

    // reset state when pressing back button
    $(window).on('pageshow', (event) => {
      if (event.originalEvent.persisted) {
        montageReserve.val('');
        montageReserve.removeClass('reservation-overlay__select--selected');
        pendryReserve.val('');
        pendryReserve.removeClass('reservation-overlay__select--selected');
      }
    });
  });
// eslint-disable-next-line no-undef
}(jQuery));
